import { render, staticRenderFns } from "./DieEemente.vue?vue&type=template&id=0aab3b0f&scoped=true"
import script from "./DieEemente.vue?vue&type=script&lang=js"
export * from "./DieEemente.vue?vue&type=script&lang=js"
import style0 from "./DieEemente.vue?vue&type=style&index=0&id=0aab3b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab3b0f",
  null
  
)

export default component.exports